import { render, staticRenderFns } from "./GiftInfo.vue?vue&type=template&id=d85d8300&scoped=true"
import script from "./GiftInfo.vue?vue&type=script&lang=js"
export * from "./GiftInfo.vue?vue&type=script&lang=js"
import style0 from "./GiftInfo.vue?vue&type=style&index=0&id=d85d8300&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85d8300",
  null
  
)

export default component.exports